import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { CountryCode } from '../enums/common/CountryCode.js';
import { OnboardingCommonOrganisationAddressType } from '../enums/organisation/OnboardingCommonOrganisationAddressType.js';
export class Address extends BaseMessage {
    addressLines;
    county;
    countryCode;
    postCode;
    addressType;
    pafData;
}
__decorate([
    Field.array({
        description: 'Address lines',
        items: {
            type: 'string',
            required: true,
            minLength: 1,
            maxLength: 60,
        },
        required: true,
        minItems: 1,
        maxItems: 7,
    }),
    __metadata("design:type", Array)
], Address.prototype, "addressLines", void 0);
__decorate([
    Field.string({
        description: 'County',
        pattern: '^[A-Za-z]+(\\s[A-Za-z]+)*$',
        required: false,
    }),
    __metadata("design:type", String)
], Address.prototype, "county", void 0);
__decorate([
    Field.enum({
        enum: CountryCode,
        required: false,
        description: 'Country code',
    }),
    __metadata("design:type", String)
], Address.prototype, "countryCode", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'Post Code',
        maxLength: 8,
    }),
    __metadata("design:type", String)
], Address.prototype, "postCode", void 0);
__decorate([
    Field.enum({
        enum: OnboardingCommonOrganisationAddressType,
        required: false,
        description: 'Address Type',
    }),
    __metadata("design:type", String)
], Address.prototype, "addressType", void 0);
__decorate([
    Field.boolean({
        description: 'PAF Data',
        required: true,
    }),
    __metadata("design:type", Boolean)
], Address.prototype, "pafData", void 0);
//# sourceMappingURL=Address.js.map